// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host{padding:20px}.attribute-wrapper{display:grid;grid-template-columns:1fr auto}.attribute-explore{justify-self:right;align-self:center}.card-text{font-size:12px}", ""]);
// Exports
module.exports = exports;
